import ShowMore from 'Root/App/Item/ShowMore'
import RenderedHtml from 'Root/Component/RenderedHtml'

export default function Presentation({ html }: { html: string }) {
  const sections = html.split('###')
  const introduction = sections.shift()

  return (
    <>
      <RenderedHtml value={introduction.replaceAll('***', '<hr>')} />
      {sections.map((section, index) => (
        <ShowMore key={index}>
          <RenderedHtml value={section.replaceAll('***', '<hr>')} />
        </ShowMore>
      ))}
    </>
  )
}
